import React, { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketDispatchBlackListContacts = ({ dispatch, searchParam }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleDispatchBlackListContacts = (data) => {
        const isTenantIdTarget = `${api.defaults.headers.tenantId}` === `${data.tenantId}`;

        if (["update", "create"].includes(data.action) && isTenantIdTarget) {
          dispatch({ type: "UPDATE_DISPATCH_BLACKLIST_CONTACTS", payload: data.dispatchBlackListContact, searchParam });
        }

        if (data.action === "delete" && isTenantIdTarget) {
          dispatch({ type: "DELETE_DISPATCH_BLACKLIST_CONTACTS", payload: +data.blackListContactId });
        }
      };

      socket.on("dispatchBlackListContacts", handleDispatchBlackListContacts);

      return () => {
        socket.off("dispatchBlackListContacts", handleDispatchBlackListContacts);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchParam]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketDispatchBlackListContacts;
